import { mapGetters } from 'vuex';
import Profile from './components/profile/Profile.vue';
import domainMixin from '../../mixins/domain';

export default {
  mixins: [domainMixin],
  components: { Profile },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'isAdmin',
      'isUser',
      'isManager'
    ]),
    ...mapGetters('Survey', [
      'hasActiveSurvey',
      'hasVoted',
      'surveyStatusLoaded',
    ]),
    activeRoute() {
      return this.$route.name;
    },
    showIndicators() {
      return this.isTmgaz || this.isLocalhost;
    },
    showSurvey() {
      return !!(this.isTmgaz || this.isLocalhost);
    },
  },
  async created() {
    if (this.showSurvey && this.isLoggedIn && !this.surveyStatusLoaded) {
      try {
        await this.$store.dispatch('Survey/fetchUserSurveyStatus');
      } catch (e) {
        console.warn('Survey status check skipped:', e.message);
      }
    }
  },
  methods: {
    handleSelect(key) {
      if (this.$route.name !== key && this.$route.path !== key && this.$route.path !== `/${key}`) {
        this.$router.push({ name: key }).catch(() => {
          this.$router.push(`/${key}`).catch(() => {});
        });
      }
    },
  },
};
